// @flow
import {SORTABLE_DIRECTION, EVENT_TYPES} from './constants';

import type {Node} from 'react';


export type SortableChangeProps = {|
    itemIds: Array<string>,
    isSingleListSorted: boolean,
    movableItemId: string,
    oldIndex: number,
    newIndex: number,
    type: $Values<typeof EVENT_TYPES>,
|};

export type DirectionType = $Keys<typeof SORTABLE_DIRECTION>;

export type OnMove = (params: ClientRect, event: any) => void;
export type OnChange = (params: SortableChangeProps) => void;
export type OnStartDrag = (event: any) => void;
export type OnEndDrag = (event: any) => void;
export type UpdateActiveList = (listName: string) => void;

export type SortableCommonProps = {|
    listName: string,
    onChange: OnChange,
    children: Node,
    fallbackClass?: string,
    containerClass?: string,
    scroll?: {|
        getScroll: () => ?HTMLElement,
        onScroll: (delta: number) => void,
    |},

    isSingleItem: boolean,
    isEmpty: boolean,
    direction: DirectionType,
    sortableTheme: string,
    sort: boolean,
    pull: boolean | string,
    put: boolean | null,
    removable: boolean,
    disabled: boolean,
    addDragToBody: boolean,
    handle?: string,
    activeListName?: string,
    updateActiveList?: UpdateActiveList,
    onHighlight: OnHighlight,
    onStartDrag?: OnStartDrag,
    onEndDrag?: OnEndDrag,
    onMove?: OnMove,
    fallbackTolerance: number,
    delay: number,
    multipleLists: boolean,
    mix: string,
    revertOriginalPosition: boolean,
    autoScrolling?: boolean,
    defaultMovement?: boolean,
|};

export type OnHighlight = (shown: boolean, index: number) => void;

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./constants");
